module.exports = __webpack_public_path__ + "static/media/(V)-Prata-05.dca7d2e3.jpg";